import ApiClient from '@/libs/http-client'

const QuestionsService = {
    endpoints(route, param) {
        const url = {
            getQuestions: '/api/assessments/questions/categories',


            getAccessQuestions: '/api/roles/accesses?access_type=edit all&entity=Assessment_questions',
            updateTeam: `/api/users/${param}`,

        }
        return url[route]
    },
    get(url, param = {}) {
        return ApiClient.get(this.endpoints(url, param));
    },
    getData(url, param = {}, data) {
    return ApiClient.get(this.endpoints(url, param), data);
  },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    postFile(url, params = {}, data, config = {}) {
        config = {
            headers: {
                "Accept": "application/json",
                "Content-Type": "multipart/form-data",
            },
            ...config
        }
        return ApiClient.post(this.endpoints(url, params), data, config);
    },

  updateQuestions( data, config) {
    return ApiClient.post(`/api/assessments/questions/categories/insert`, data, config)
  },

  addSingleQuestion(data, config) {
    return ApiClient.post(`/api/assessments/questions/`, data, config)
  },

  setViewRoles( data, config) {
    return ApiClient.post(`/api/roles/accesses?access_type=show all&entity=Assessment_answers`, data, config)
  },

  setQuestionRoles( data, config) {
    return ApiClient.post(`/api/roles/accesses`, data, config)
  },


}

export default QuestionsService
